import NiceModal from '@ebay/nice-modal-react';

import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';

import useDraggable from 'hooks/useDraggable';

import { resetVideoPopup } from 'stores/videoSlice';

import { faArrowUpRightFromSquare, faUpDownLeftRight, faXmark } from '@fortawesome/pro-solid-svg-icons';

import Icon from './Icon';
import Image from './Image';
import Skeleton from './Skeleton';
import Typography from './Typography';
import { VideoModal } from './Video';
import YoutubePlayer from './YoutubePlayer';
import * as S from './styled/VideoPortal.styled';

/**
 * @author @buunsal
 * @description VideoPopPortal is a component that is used to display a video poppedup.
 */
const VideoPortal = () => {
	// containerRef is the reference of the container that we can drag
	const [draggableRef, setDraggableRef] = useState();
	// react player ref
	const videoRef = useRef();

	const [loading, setLoading] = useState(true);

	const dispatch = useDispatch();
	const { t } = useTranslation();

	const videoInfos = useSelector((state) => state.videoPopup);
	const { title, popup, autoplay, progress, videoId, volume, logo } = videoInfos;

	// If we click the close button, we should reset the video popup
	const removeVideoPopup = () => {
		dispatch(resetVideoPopup());
	};

	useDraggable(draggableRef);
	return (
		popup &&
		autoplay && (
			<S.Container ref={setDraggableRef}>
				<S.Header>
					<S.LeftContainer>
						<Image url={logo} style={{ borderRadius: '50%' }} width="4rem" height="4rem" />
						<span className="mx-2" />
						<div className="mb-2">
							<Typography fontWeight="500">{title}</Typography>
							<Typography
								color="var(--blue)"
								style={{ cursor: 'pointer' }}
								onClick={() => window.open(t('helpCenterLink'))}>
								popup.seeMoreVideos
							</Typography>
						</div>
					</S.LeftContainer>
					<Button
						variant="borderless"
						icon={faXmark}
						onClick={removeVideoPopup}
						iconSize="medium"
						iconButton
					/>
				</S.Header>
				<div style={{ position: 'relative', width: '50rem', height: '30rem' }}>
					{loading && (
						<Skeleton
							width={'100%'}
							height={'100%'}
							style={{ position: 'absolute', top: 0, left: 0, zIndex: 1, borderRadius: 0 }}
						/>
					)}
					<YoutubePlayer
						videoId={videoId}
						ref={videoRef}
						playing
						controls
						autoplay={autoplay}
						progress={progress}
						onReady={() => setLoading(false)}
						volume={volume}
					/>
				</div>
				<S.BottomContainer className="mt-2">
					<Button
						variant="borderless"
						icon={faArrowUpRightFromSquare}
						onClick={() => {
							NiceModal.show(VideoModal, {
								...videoInfos,
								progress,
								isPlaying: true
							});
							removeVideoPopup();
							setLoading(true);
						}}
						iconSize="medium"
						iconButton
					/>
					<Icon icon={faUpDownLeftRight} size="medium" className="p-2" />
				</S.BottomContainer>
			</S.Container>
		)
	);
};

export default VideoPortal;
